"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var payloadAssemblerManager_1 = require("./payloads/payloadAssemblerManager");
var sendOperations_1 = require("./payloads/sendOperations");
var streamManager_1 = require("./payloads/streamManager");
var protocol_base_1 = require("./utilities/protocol-base");
/**
 * Creates a protocol adapter for Streaming.
 */
var ProtocolAdapter = /** @class */ (function () {
    /// <summary>
    /// Creates a new instance of the protocol adapter class.
    /// </summary>
    /// <param name="requestHandler">The handler that will process incoming requests.</param>
    /// <param name="requestManager">The manager that will process outgoing requests.</param>
    /// <param name="sender">The sender for use with outgoing requests.</param>
    /// <param name="receiver">The receiver for use with incoming requests.</param>
    function ProtocolAdapter(requestHandler, requestManager, sender, receiver) {
        var _this = this;
        this.requestHandler = requestHandler;
        this.requestManager = requestManager;
        this.payloadSender = sender;
        this.payloadReceiver = receiver;
        this.sendOperations = new sendOperations_1.SendOperations(this.payloadSender);
        this.streamManager = new streamManager_1.StreamManager(this.onCancelStream);
        this.assemblerManager = new payloadAssemblerManager_1.PayloadAssemblerManager(this.streamManager, function (id, response) { return _this.onReceiveResponse(id, response); }, function (id, request) { return _this.onReceiveRequest(id, request); });
        this.payloadReceiver.subscribe(function (header) { return _this.assemblerManager.getPayloadStream(header); }, function (header, contentStream, contentLength) {
            return _this.assemblerManager.onReceive(header, contentStream, contentLength);
        });
    }
    /**
     * Sends a request over the attached request manager.
     * @param request The outgoing request to send.
     * @returns The response to the specified request.
     */
    ProtocolAdapter.prototype.sendRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var requestId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestId = protocol_base_1.generateGuid();
                        return [4 /*yield*/, this.sendOperations.sendRequest(requestId, request)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.requestManager.getResponse(requestId)];
                }
            });
        });
    };
    /**
     * Executes the receive pipeline when a request comes in.
     * @param id The id the resources created for the response will be assigned.
     * @param request The incoming request to process.
     */
    ProtocolAdapter.prototype.onReceiveRequest = function (id, request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.requestHandler) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.requestHandler.processRequest(request)];
                    case 1:
                        response = _a.sent();
                        if (!response) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.sendOperations.sendResponse(id, response)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Executes the receive pipeline when a response comes in.
     * @param id The id the resources created for the response will be assigned.
     * @param response The incoming response to process.
     */
    ProtocolAdapter.prototype.onReceiveResponse = function (id, response) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestManager.signalResponse(id, response)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Executes the receive pipeline when a cancellation comes in.
     * @param contentStreamAssembler The payload assembler processing the incoming data that this cancellation request targets.
     */
    ProtocolAdapter.prototype.onCancelStream = function (contentStreamAssembler) {
        this.sendOperations.sendCancelStream(contentStreamAssembler.id).catch();
    };
    return ProtocolAdapter;
}());
exports.ProtocolAdapter = ProtocolAdapter;
//# sourceMappingURL=protocolAdapter.js.map